import styled from 'styled-components';

// Mesmo visual da faixa de atraso (DelayRangeFilter) e do seletor da Carteira.
export const FilterBar = styled.div.attrs({})`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
`;

export const FilterGroup = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
`;

export const FilterLabel = styled.span.attrs({})`
  font-size: 12px;
  text-transform: uppercase;
  color: #718096;
  white-space: nowrap;
`;

export const FilterField = styled.div.attrs({})`
  width: 140px;
`;

export const FilterSeparator = styled.span.attrs({})`
  font-size: 13px;
  color: #718096;
`;

export const FilterError = styled.span.attrs({})`
  font-size: 12px;
  color: #dd4952;
`;
